import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import Section from '../components/Section';
import Footer from '../components/Footer';

import '../styles/BlogPost.css';

function BlogPost() {
    const [post, setPost] = useState(null);
    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const controller = new AbortController();

        fetch(`https://ryonasset.com/api/posts/${id}`, { signal: controller.signal })
            .then(response => {
                if (response.ok) {
                    return response.json();
                }

                alert('The blog post you are looking for does not exist. Redirecting to the blog list.');
                navigate('/blog', { replace: true });
                throw new Error('Network response was not ok.');
            })
            .then(data => {
                setPost(data);
            })
            .catch(error => {
                if (error.name !== 'AbortError') {
                    console.error('Fetch error:', error);
                }
            });

        return () => {
            controller.abort();
        };
    }, [id, navigate]);

    if (!post) {
        return <div>Loading...</div>;
    }

    return (
        <div className='main-wrapper'>
            <main style={{paddingTop:'100px'}}>
                <Section title={post.title}>
                    <div className="sect-side-space">
                        <div className='blog-post-info'>
                            <div className='blog-post-author'>{post.author}</div>
                            <div className='blog-post-date'>{post.date}</div>
                        </div>
                        <hr />
                        <div className='blog-post-content'>
                            <ReactMarkdown>{post.content}</ReactMarkdown>
                        </div>
                    </div>
                </Section>
            </main>
            <Footer />
        </div>
    );
}

export default BlogPost;
